import { useContext, useState } from 'react';
import { ReportContext } from '../Context';
import { 
  Button, 
  Box, 
  Paper, 
  Container, 
  Typography, 
  Grid,
  Tab, 
  Tabs,
  Fade,
  Divider
} from '@mui/material';
import ReportsList from './ReportsList';
import AddIcon from '@mui/icons-material/Add';
import FolderIcon from '@mui/icons-material/Folder';
import ArchiveIcon from '@mui/icons-material/Bookmark';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';

function Dashboard() {
  const { pickReport } = useContext(ReportContext);
  const [selectedView, setSelectedView] = useState('personal');

  const handleNewReport = () => {
    pickReport({ new: true });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedView(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ pt: 4, pb: 6 }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: 3, 
          borderRadius: 3,
          bgcolor: 'background.paper',
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: { xs: 2, md: 0 } }}>
            <HomeIcon
              aria-hidden="true"
              sx={{
                fontSize: 38,
                color: 'primary.main',
                flexShrink: 0,
              }}
            />
            <Typography 
              variant="h4" 
              component="h1" 
              sx={{ 
                fontWeight: 700, 
                color: 'primary.main',
              }}
            >
              Mon tableau de bord
            </Typography>
          </Box>
          
          <Button
            variant="contained"
            color="primary"
            onClick={handleNewReport}
            startIcon={<AddIcon />}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1.2,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
              '&:hover': {
                boxShadow: '0 6px 16px rgba(25, 118, 210, 0.3)',
                transform: 'translateY(-2px)',
                transition: 'all 0.2s'
              }
            }}
          >
            Nouveau document
          </Button>
        </Box>
        
        <Divider sx={{ mb: 4 }} />

        <Box sx={{ width: '100%' }}>
          <Tabs
            value={selectedView}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              mb: 3,
              '& .MuiTabs-indicator': {
                height: 3,
                borderTopLeftRadius: 3,
                borderTopRightRadius: 3
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 500,
                py: 2,
                transition: 'all 0.2s',
                '&.Mui-selected': {
                  fontWeight: 600
                }
              }
            }}
          >
            <Tab 
              icon={<FolderIcon />} 
              iconPosition="start"
              label="Mes documents" 
              value="personal" 
              sx={{ borderRadius: '8px 0 0 8px' }}
            />
            <Tab 
              icon={<ArchiveIcon />} 
              iconPosition="start"
              label="Mes archives" 
              value="archived" 
            />
            <Tab 
              icon={<HistoryIcon />} 
              iconPosition="start"
              label="Derniers documents" 
              value="last50" 
              sx={{ borderRadius: '0 8px 8px 0' }}
            />
          </Tabs>
          
          <Box sx={{ mt: 2 }}>
            <Fade in={selectedView === 'personal'} timeout={500} unmountOnExit>
              <div>{selectedView === 'personal' && <ReportsList viewType="personal" />}</div>
            </Fade>
            <Fade in={selectedView === 'archived'} timeout={500} unmountOnExit>
              <div>{selectedView === 'archived' && <ReportsList viewType="archived" />}</div>
            </Fade>
            <Fade in={selectedView === 'last50'} timeout={500} unmountOnExit>
              <div>{selectedView === 'last50' && <ReportsList viewType="last50" />}</div>
            </Fade>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}

export default Dashboard;